import React, { ReactNode } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface ChartCardProps {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
}

export function ChartCard({ title, icon, children, actions }: ChartCardProps) {
  const { isDark } = useTheme();

  return (
    <div
      className="rounded-lg"
      style={{
        backgroundColor: isDark ? '#1D293D' : '#FFFFFF',
        border: `1px solid ${isDark ? '#314158' : '#E2E8F0'}`,
        boxShadow: isDark ? '0px 1px 2px rgba(2, 6, 24, 0.5)' : '0px 1px 2px rgba(43, 127, 255, 0.1)',
      }}
    >
      <div
        className="px-5 py-3 flex items-center justify-between"
        style={{
          borderBottom: `1px solid ${isDark ? '#1D293D' : '#F1F5F9'}`,
        }}
      >
        <h3
          className="text-sm font-semibold flex items-center"
          style={{ color: isDark ? '#E2E8F0' : '#314158' }}
        >
          {icon && <span className="mr-2 flex items-center">{icon}</span>}
          {title}
        </h3>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      <div className="p-5">
        {children}
      </div>
    </div>
  );
}
